import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { translationToStr } from '@frontend/sports/common/core/utils/translations';
import { MeetingModel, WinGameFixture } from '@frontend/sports/racing/feature/models';
import { EMPTY, Observable, catchError, map, of, switchMap } from 'rxjs';

import { getDayOfRace } from '../../../horse-racing-shared/helpers';
import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';
import { HorsesFixtureHelper } from '../../../horse-racing-shared/services/horses-fixture-helper.service';

export interface HorsesRaceDetailsModel extends MeetingModel {
    fixture: WinGameFixture;
}

@Injectable()
export class HorsesRaceDetailsResolver {
    constructor(
        private apiService: HorseRacingApiService,
        private horsesFixtureHelper: HorsesFixtureHelper,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HorsesRaceDetailsModel | undefined> {
        const fixtureId = route.params.raceId;
        if (!fixtureId) {
            return of(undefined);
        }

        return this.apiService.getFixture(fixtureId).pipe(
            switchMap((fixture) => {
                if (!fixture) {
                    return EMPTY;
                }
                const day = getDayOfRace(fixture.startDate);
                fixture.addons.bestOddsGuarantee = this.horsesFixtureHelper.checkIfBOGApplicable(fixture);

                const def: HorsesRaceDetailsModel = {
                    fixture,
                    fixtures: [],
                    meeting: {
                        id: fixture.meeting.id,
                        name: translationToStr(fixture.meeting.name),
                    },
                    day,
                };
                const meetingId = fixture.meeting.id;

                return this.apiService.getMeeting(meetingId, day).pipe(
                    map(
                        (fixtures) =>
                            ({
                                fixture,
                                fixtures,
                                meeting: {
                                    id: fixture.meeting.id,
                                    name: translationToStr(fixture.meeting.name),
                                },
                                day,
                            }) as HorsesRaceDetailsModel,
                    ),
                    catchError(() => of(def)),
                );
            }),
            catchError(() => of(undefined)),
        );
    }
}
